import { useMemo } from "react"
import PropTypes from "prop-types"
import { ClickAwayListener } from "@mui/material"
import { map } from "lodash"
import moment from "moment"
import { PERIOD_OPTIONS } from "helpers/dates"
import Option from "./option"

export default function PeriodSelectorOptions({
  period,
  customizeOptions,
  handleClickAway,
  handleSelect,
  handleResetOption = null,
  endDate = null,
  latestDate = null,
  isIntradayEnabled = false,
  isIntradayBatchAvailable = false,
  isEndDateToday = false,
  intradayAsOf = null,
  intradayRelativeDay = "today",
}) {
  const options = useMemo(
    () => customizeOptions ? customizeOptions(PERIOD_OPTIONS) : PERIOD_OPTIONS,
    [customizeOptions],
  )
  const endDateIsLatest = moment(endDate).isSame(moment(latestDate), "day")
  const selectorTitle = handleResetOption && period === "CUSTOM"
    ? "Custom Time Window"
    : "Select Time Window"

  const isIntradayWithData = isIntradayEnabled && isIntradayBatchAvailable
  const showResetToToday = isIntradayEnabled && !isEndDateToday
  const showResetToCurrent = !isIntradayEnabled && !endDateIsLatest

  const dropdownDescription = isIntradayWithData && isEndDateToday ? (
    <>
      Window relative to<br />{intradayRelativeDay} @ {intradayAsOf}
    </>
  ) : (
    `Window relative to ${endDate.format("MMM D, YYYY")}`
  )

  const onResetClick = () => {
    if (handleResetOption) {
      handleResetOption()
    }
    handleClickAway()
  }

  const resetOption = (showResetToToday || showResetToCurrent) ? (
    <a className="link" onClick={onResetClick}>
      {showResetToToday ? "Reset to today" : "Reset to current"}
    </a>
  ) : null

  return <ClickAwayListener onClickAway={handleClickAway}>
    <div className="dropdown">
      <div className="title">{selectorTitle}</div>
      {handleResetOption && <>
        <div className="description">{dropdownDescription}</div>
        {resetOption}
        <hr />
      </>}
      {map(options, ({ value, label }) =>
        <Option key={value} value={value} label={label} select={handleSelect} period={period} />,
      )}
    </div>
  </ClickAwayListener>
}

PeriodSelectorOptions.propTypes = {
  period: PropTypes.string.isRequired,
  customizeOptions: PropTypes.func,
  handleClickAway: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleResetOption: PropTypes.func,
  endDate: PropTypes.string,
  latestDate: PropTypes.string,
  isIntradayEnabled: PropTypes.bool,
  isIntradayBatchAvailable: PropTypes.bool,
  isEndDateToday: PropTypes.bool,
  intradayAsOf: PropTypes.string,
  intradayRelativeDay: PropTypes.string,
}
